import React from "react"
import "twin.macro"
import { graphql, useStaticQuery } from "gatsby"
import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image"

const school = [
  {
    year: "from-to",
    col: "University 1",
    deg: "Degree 1",
  },
  {
    year: "from-to",
    col: "University 2",
    deg: "Degree 2",
  },
]
type dataType = {
  allWorkJson: {
    nodes: {
      year: String
      name: String
      desc: String
      company: String
      image: ImageDataLike
    }[]
  }
}
const Experience = () => {
  const data: dataType = useStaticQuery(graphql`
    query workQuery {
      allWorkJson {
        nodes {
          year
          name
          company
          desc
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)
  const AllData = data.allWorkJson.nodes
  return (
    <div>
      {/* middle side */}
      <div tw="bg-white max-w-3xl md:col-span-5 shadow-2xl">
        <h1 tw="mt-3.5 ml-4 text-2xl font-semibold pt-8 pl-6">
          WORK EXPERIENCE
        </h1>

        <div tw="container">
          {AllData.map((item, index) => {
            const image = getImage(item.image)
            return (
              <div tw="flex flex-col md:grid grid-cols-9 mx-auto p-2 ">
                <div tw="flex flex-row-reverse md:contents">
                  <div tw=" col-start-1 col-end-5 p-4  my-4 ml-auto ">
                    <h3 tw="font-semibold text-lg mb-1 px-2 bg-blue-300">
                      {item.year}
                    </h3>
                  </div>
                  <div tw="col-start-5 col-end-6 md:mx-auto relative mr-10">
                    <div tw="h-full w-6 flex items-center justify-center">
                      <div tw="h-full w-1 bg-blue-200 pointer-events-none"></div>
                    </div>
                    <div tw="w-2 h-2 absolute top-10 ml-2 rounded-full bg-black shadow"></div>
                  </div>
                </div>

                <div tw="flex md:contents">
                  <div tw="col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto ">
                    <h3 tw="font-semibold text-lg mb-1 ">{item.name}</h3>
                    <div tw=" transform scale-50 ">
                      <GatsbyImage
                        image={image as IGatsbyImageData}
                        alt="photo"
                        tw="p-4 -ml-32 w-40 h-8 "
                      />
                    </div>
                    <p tw="font-semibold opacity-50 text-xl pt-1">
                      {item.company}
                    </p>
                    <p tw="leading-tight text-sm pt-2 text-justify">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        <hr tw="mt-3" />
        <h1 tw="mt-3.5 ml-4 text-2xl font-semibold pt-4 pl-6">EDUCATION</h1>

        <div tw="container p-6">
          {school.map((item, index) => (
            <div tw="flex flex-col md:grid grid-cols-9 mx-auto p-2 ">
              <div tw="flex flex-row-reverse md:contents">
                <div tw=" col-start-3 col-end-5 p-4  my-4 ml-auto ">
                  <div tw="flex m-auto ">
                    <h3 tw="font-semibold text-lg mb-1 px-2  bg-blue-300">
                      {item.year}
                    </h3>
                  </div>
                </div>

                <div tw="col-start-5 col-end-6 md:mx-auto relative mr-10">
                  <div tw="h-full w-6 flex items-center justify-center">
                    <div tw="h-full w-1 bg-blue-200 pointer-events-none"></div>
                  </div>
                  <div tw="w-3 h-3 absolute top-7 ml-1.5 rounded-full bg-black shadow"></div>
                </div>
              </div>

              <div tw="flex md:contents">
                <div tw="col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto ">
                  <h3 tw="font-semibold text-lg mb-1 ">{item.col}</h3>
                  <p tw="font-semibold opacity-50">{item.deg} </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default Experience
